/* eslint-disable no-useless-escape */
import { Inject, Injectable } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { NotificationKind } from 'src/types/graphql';
import { routes } from '../../../../utils/routes';
import { UserService } from '../user/user.service';

@Injectable({ providedIn: 'root' })
export class SlugService {
  constructor(
    @Inject(I18NEXT_SERVICE) private translateService: ITranslationService,
    private userService: UserService,
  ) {}

  slug(value: any, instanceId?: string, userId?: string, kind?: string, secondaryRef?: any): string {
    if (!value) return '';
    switch (value.__typename) {
      case 'Banner':
      case 'LikeCollection':
        return `/${this.translateService.language}/${routes[this.translateService.language as 'it'][`routes.likes`]}/${
          value.slug
        }`;
      case 'Conversation':
        return `/${this.translateService.language}/${
          routes[this.translateService.language as 'it'][`routes.messages`]
        }?conversationId=${value.id}`;
      case 'User':
        if (!!kind && kind === NotificationKind.UserDeleteBooking) {
          if (this.userService.user?.id === secondaryRef?.owner?.id) {
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.dashboard/bookings`]
            }?sharryCartItemStatus=${secondaryRef.item_status}&value\=PR${secondaryRef.id}`;
          } else {
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.sharry-activity/bookings`]
            }?sharryCartItemStatusUser=${secondaryRef.item_status}&value\=PR${secondaryRef.id}`;
          }
        }
        if ((!!kind && kind === NotificationKind.NewUser) || kind === NotificationKind.AppleLoginBlankName) {
          return `/${this.translateService.language}/${
            routes[this.translateService.language as 'it'][`routes.profile/home`]
          }`;
        }
        return `/${this.translateService.language}/${
          routes[this.translateService.language as 'it'][`routes.profile`]
        }/${value.slug}`;
      case 'BecomePro':
        return `/${this.translateService.language}/${
          routes[this.translateService.language as 'it'][`routes.become-pro`]
        }`;
      case 'LoginBlank':
        return `/${this.translateService.language}/${
          routes[this.translateService.language as 'it'][`routes.profile/home`]
        }`;
      case 'CustomLink':
        return `/${this.translateService.language}/${routes[this.translateService.language as 'it'][`routes.go`]}/${
          value.slug
        }`;
      case 'Faq':
        return `/${this.translateService.language}/${routes[this.translateService.language as 'it'][`routes.faq`]}/${
          value.slug
        }`;
      case 'FaqSection':
        return `/${this.translateService.language}/${routes[this.translateService.language as 'it'][`routes.faq`]}/${
          value.faq.slug
        }/${value.slug}`;
      case 'FaqBody':
        //TODO
        return '';
      case 'SharryReview':
        if (value.reviewContent) {
          return `/${this.translateService.language}/${
            routes[this.translateService.language as 'it'][
              `routes.${value.reviewContent.contentType === 'post' ? 'community' : value.reviewContent.contentType}`
            ]
          }/${value.reviewContent.slug}?highlightedId=${value.id}`;
        } else {
          return `/${this.translateService.language}/${
            routes[this.translateService.language as 'it']['routes.likes']
          }/${value.reviewCollection.slug}?highlightedId=${value.id}`;
        }
      case 'Post':
        return `/${this.translateService.language}/${
          routes[this.translateService.language as 'it'][`routes.community`]
        }/${value.slug}`;
      case 'CartItem':
        switch (kind) {
          case NotificationKind.CartItemCreateOwner:
          case NotificationKind.CartItemPaidOwner:
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.dashboard/bookings`]
            }?sharryCartItemStatus=${value.item_status}&value\=PR${value.id}`;
          case NotificationKind.CartItemAccepted:
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.cart`]
            }`;
          case NotificationKind.CartItemRejected:
          case NotificationKind.SharryDayBefore:
          case NotificationKind.Sharry_15Before:
          case NotificationKind.CartItemPaidUser:
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.sharry-activity/bookings`]
            }?sharryCartItemStatusUser=${value.item_status}&value\=PR${value.id}`;
          case NotificationKind.SharryLeaveComment:
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.sharries`]
            }/${value.sharryContent.slug}`;
          default:
            return '';
        }
      case 'UserCherryGoal':
        return `/${this.translateService.language}/${
          routes[this.translateService.language as 'it'][`routes.cherry-meter`]
        }`;

      case 'Land':
        return `/${this.translateService.language}/${routes[this.translateService.language as 'it'][`routes.land`]}/${
          value.slug
        }`;

      default:
        if (value.contentType === 'sharry') {
          if (instanceId) {
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.sharries`]
            }/${value.slug}/${routes[this.translateService.language as 'it']['routes.instances']}/${instanceId}`;
          } else {
            return `/${this.translateService.language}/${
              routes[this.translateService.language as 'it'][`routes.sharries`]
            }/${value.slug}`;
          }
        } else {
          return `/${this.translateService.language}/${
            routes[this.translateService.language as 'it'][`routes.${value.contentType}s`]
          }/${value.slug}`;
        }
    }
  }
}
